import { Component } from "react";


export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Smartly ErrorBoundary caught:", error, errorInfo);
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <div
        className="flex min-h-screen items-center justify-center bg-[radial-gradient(circle_at_top,_rgba(255,209,102,0.35),_transparent_35%),linear-gradient(180deg,_#fbf7ef_0%,_#f4efe3_45%,_#edf3ea_100%)] px-6"
        style={{ minHeight: "100dvh", paddingTop: "env(safe-area-inset-top)", paddingBottom: "env(safe-area-inset-bottom)" }}
        data-testid="error-boundary-fallback"
      >
        <div className="w-full max-w-sm rounded-[30px] border border-stone-200/70 bg-white/85 p-8 text-left shadow-[0_30px_80px_rgba(44,62,38,0.12)] backdrop-blur">
          <p className="text-xs font-semibold uppercase tracking-[0.32em] text-emerald-700">
            Smartly Meals
          </p>
          <h1 className="mt-4 text-3xl font-semibold text-stone-900" data-testid="error-boundary-title">
            Er ging iets mis
          </h1>
          <p className="mt-3 text-sm text-stone-600">
            De app liep tegen een onverwachte fout aan. Herlaad de pagina om verder te gaan — je gegevens zijn veilig opgeslagen.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="mt-6 h-12 w-full rounded-full bg-emerald-700 text-sm font-semibold text-white transition-colors hover:bg-emerald-800"
            data-testid="error-boundary-reload-button"
          >
            Herlaad de app
          </button>
        </div>
      </div>
    );
  }
}
